import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ObjectTypeName from 'automation-ui-references/object-types/ObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedMessageWithObjectTypeName = ({
  baseLangKey,
  objectTypeId,
  options = {},
  isJsx = false,
  elements
}) => {
  let message = baseLangKey;
  if (isJsx && !baseLangKey.endsWith('_jsx')) {
    message = `${baseLangKey}_jsx`;
  }
  const allOptions = Object.assign({}, options, {
    objectTypeName: /*#__PURE__*/_jsx(ObjectTypeName, {
      objectTypeId: objectTypeId,
      isCapitalized: false,
      isPlural: false
    }),
    objectTypeNamePlural: /*#__PURE__*/_jsx(ObjectTypeName, {
      objectTypeId: objectTypeId,
      isCapitalized: false,
      isPlural: true
    }),
    objectTypeNameCapitalized: /*#__PURE__*/_jsx(ObjectTypeName, {
      objectTypeId: objectTypeId,
      isCapitalized: true,
      isPlural: false
    }),
    objectTypeNamePluralAndCapitalized: /*#__PURE__*/_jsx(ObjectTypeName, {
      objectTypeId: objectTypeId,
      isCapitalized: true,
      isPlural: true
    })
  });
  return isJsx ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: message,
    options: allOptions,
    elements: elements
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: message,
    options: allOptions
  });
};
export default FormattedMessageWithObjectTypeName;